import { createContext } from 'react';

import { MediaFolderTree } from '@atom/types/media';

import { PendingEdit } from '../types';

type Context = {
  expandedIds: Set<string>;
  onToggleExpand: (id: string) => void;
  selectedId: string;
  onSelect: (folder: MediaFolderTree) => void;
  disabledIds: Set<string>;
  movingFolderId: string;
  isFolderMove: boolean;
  editing: PendingEdit | null;
  loadingUpdate: boolean;
  onStartCreate: (parentId: string) => void;
  onStartRename: (id: string, name: string) => void;
  onChangeEditingName: (name: string) => void;
  onSaveEditing: () => void;
  onCancelEditing: () => void;
};

export const initialState: Context = {
  expandedIds: new Set(),
  onToggleExpand: () => {},
  selectedId: '',
  onSelect: () => {},
  disabledIds: new Set(),
  movingFolderId: '',
  isFolderMove: false,
  editing: null,
  loadingUpdate: false,
  onStartCreate: () => {},
  onStartRename: () => {},
  onChangeEditingName: () => {},
  onSaveEditing: () => {},
  onCancelEditing: () => {},
};

const MoveFolderTreeContext = createContext<Context>(initialState);

export default MoveFolderTreeContext;
